// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Button,
//   Box,
//   CircularProgress,
//   useTheme,
// } from "@mui/material";
// import { Link, useNavigate } from "react-router-dom";

// import { wakeInstantId } from "../../api/campaignApi";

// const accent = "#7A3CFF";

// export default function Header() {
//   const [isWaking, setIsWaking] = useState(false);
//   const navigate = useNavigate();

//   const handleStart = () => {
//     if (window.fbq) {
//       window.fbq("track", "Lead", {
//         content_name: "Started Creation Process",
//         source: "Header Create click",
//       });
//     }
//     navigate("/stepper");
//   };

//   const Logo = () => (
//     <Box
//       component={Link}
//       to="/"
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         textDecoration: "none",
//         gap: 1,
//       }}
//     >
//       <Box
//         component="img"
//         src="/images-icons/customFableLogo.svg"
//         alt="CustomFable Logo Icon"
//         sx={{
//           height: { xs: 28, md: 32 },
//           width: "auto",
//         }}
//       />
//       <Box
//         component="img"
//         src="/images-icons/customFableLogoText.svg"
//         alt="CustomFable Logo Text"
//         sx={{
//           height: { xs: 22, md: 26 },
//           width: "auto",
//         }}
//       />
//     </Box>
//   );

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{ bgcolor: "#FFFFFF", borderBottom: "1px solid #F0F0F5" }}
//       >
//         <Toolbar
//           sx={{
//             minHeight: { xs: 56, md: 72 },
//             px: { xs: 2, md: 4 },
//             display: "flex",
//             // Завжди 'space-between'
//             justifyContent: "space-between",
//           }}
//         >
//           <Logo />=
//           <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
//             <Button
//               onClick={handleStart}
//               disabled={isWaking}
//               variant="contained"
//               sx={{
//                 borderRadius: 999,
//                 textTransform: "none",
//                 px: 3,
//                 py: 1,
//                 fontWeight: 600,
//                 bgcolor: accent,
//                 color: "#FFFFFF",
//                 "&:hover": { bgcolor: "#612EE0" },
//                 // Змінено: 'inline-flex' для всіх розмірів
//                 display: "inline-flex",
//               }}
//             >
//               {isWaking ? (
//                 <CircularProgress size={24} color="inherit" />
//               ) : (
//                 "Get Started"
//               )}
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>
//     </>
//   );
// }




import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language"; // Planet icon
import { useTranslation } from "react-i18next"; // i18n hook

// Check your API path
import { wakeInstantId } from "../../api/campaignApi";

const accent = "#7A3CFF";

// --- LANGUAGE SWITCHER COMPONENT ---
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lng) => {
    setAnchorEl(null);
    if (lng) {
      i18n.changeLanguage(lng);
    }
  };

  // Display current language code (EN, FR, etc.)
  const currentLang = i18n.language ? i18n.language.split("-")[0].toUpperCase() : "EN";

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{ 
          color: "#1F1F1F", 
          mr: 1, 
          "&:hover": { color: accent } 
        }}
        aria-controls={open ? "language-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <LanguageIcon />
        <Box component="span" sx={{ fontSize: "0.85rem", fontWeight: 600, ml: 0.5 }}>
          {currentLang}
        </Box>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(null)}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, minWidth: 120, borderRadius: 3 }
        }}
      >
        <MenuItem onClick={() => handleClose("en")}>English</MenuItem>
        <MenuItem onClick={() => handleClose("fr")}>Français</MenuItem>
        <MenuItem onClick={() => handleClose("es")}>Español</MenuItem>
        <MenuItem onClick={() => handleClose("de")}>Deutsch</MenuItem>
      </Menu>
    </>
  );
};

// --- MAIN HEADER COMPONENT ---
export default function Header() {
  const { t } = useTranslation(); // Use translation hook
  const [isWaking, setIsWaking] = useState(false);
  const navigate = useNavigate();

  const handleStart = () => {
    if (window.fbq) {
      window.fbq("track", "Lead", {
        content_name: "Started Creation Process",
        source: "Header Create click",
      });
    }
    navigate("/stepper");
  };

  const Logo = () => (
    <Box
      component={Link}
      to="/"
      sx={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
        gap: 1,
      }}
    >
      <Box
        component="img"
        src="/images-icons/customFableLogo.svg"
        alt="CustomFable Logo Icon"
        sx={{
          height: { xs: 28, md: 32 },
          width: "auto",
        }}
      />
      <Box
        component="img"
        src="/images-icons/customFableLogoText.svg"
        alt="CustomFable Logo Text"
        sx={{
          height: { xs: 22, md: 26 },
          width: "auto",
        }}
      />
    </Box>
  );

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{ bgcolor: "#FFFFFF", borderBottom: "1px solid #F0F0F5" }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 56, md: 72 },
            px: { xs: 2, md: 4 },
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Logo />
          
          <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
            
            {/* Language Switcher added here */}
            <LanguageSwitcher />

            <Button
              onClick={handleStart}
              disabled={isWaking}
              variant="contained"
              sx={{
                borderRadius: 999,
                textTransform: "none",
                px: 3,
                py: 1,
                fontWeight: 600,
                bgcolor: accent,
                color: "#FFFFFF",
                "&:hover": { bgcolor: "#612EE0" },
                display: "inline-flex",
                whiteSpace: "nowrap" // Prevents text wrapping on language change
              }}
            >
              {isWaking ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                // Used the key we just added to nav
                t('nav.getStarted') 
              )}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}